import axios from 'axios';

/**
 * Service for interacting with Node.js API endpoints
 */
const nodeApi = {
  /**
   * Base URL for API endpoints - using relative URL to avoid CSP issues
   */
  baseUrl: '/api',

  /**
   * Register a new user
   * @param {Object} userData - User registration data
   * @returns {Promise<Object>} - Response from the server
   */
  register: async (userData) => {
    try {
      console.log('Sending registration request to:', `${nodeApi.baseUrl}/register`);
      console.log('Registration data:', userData);
      
      const response = await axios.post(`${nodeApi.baseUrl}/register`, userData);
      
      console.log('Registration response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Registration error:', error);
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return {
          success: false,
          message: error.response.data.message || 'Registration failed. Please try again later.'
        };
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: 'No response from server. Please check your internet connection and try again.'
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: `Failed to connect to the server: ${error.message}`
        };
      }
    }
  },

  /**
   * Send a contact form message
   * @param {Object} contactData - Contact form data
   * @returns {Promise<Object>} - Response from the server
   */
  contact: async (contactData) => {
    try {
      console.log('Sending contact request to:', `${nodeApi.baseUrl}/contact`);
      console.log('Contact data:', contactData);
      
      const response = await axios.post(`${nodeApi.baseUrl}/contact`, contactData);
      
      console.log('Contact response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Contact form error:', error);
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return {
          success: false,
          message: error.response.data.message || 'Failed to send message. Please try again later.'
        };
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: 'No response from server. Please check your internet connection and try again.'
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: `Failed to connect to the server: ${error.message}`
        };
      }
    }
  },

  /**
   * Test the API connection
   * @returns {Promise<Object>} - Response from the server
   */
  test: async () => {
    try {
      console.log('Testing API connection to:', `${nodeApi.baseUrl}/test`);
      
      const response = await axios.get(`${nodeApi.baseUrl}/test`);
      
      console.log('Test response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API test error:', error);
      
      return {
        success: false,
        message: `Failed to connect to the server: ${error.message}`
      };
    }
  }
};

export default nodeApi;
